export const getRpcConfigUrl = () => {
    // Direct URL override — takes precedence over all env-based logic.
    // Set REACT_APP_RPC_CONFIG_URL in the build to point at a non-default host
    // (e.g. enterprise-workflow-mf-stg.instinct.pltsci.com for staging experiments).
    if (process.env.REACT_APP_RPC_CONFIG_URL) {
        return process.env.REACT_APP_RPC_CONFIG_URL
    }

    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost:3003'
    }
    
    switch (process.env.REACT_APP_ENV) {
        case 'staging':
            return 'https://enterprise-workflow-mf-stg.instinct.pltsci.com'
        
        default:
            return 'https://enterprise-workflow-mf-stg.instinct.pltsci.com'
    }
}
